<template>
	<div>
		<egranty-section-divider text="Koszty"/>

		<v-btn
			for="invoice-form-costs-add"
			id="invoice-form-costs-add"
			@click="openAddCostDialog">
			dodaj Koszt programowy
		</v-btn>

		<v-btn
			for="invoice-form-administrative-costs-add"
			id="invoice-form-administrative-costs-add"
			@click="openAddAdministrativeCostDialog">
			dodaj Koszt administracyjny
		</v-btn>

		<div>
			<h2 style="padding: 20px">P. Koszty programowe</h2>
			<v-card outlined>
				<v-layout>
					<v-flex style="padding: 5px" sm1><b>lp</b></v-flex>
					<v-flex style="padding: 5px" sm3><b>nazwa działania</b></v-flex>
					<v-flex style="padding: 5px" sm3><b>nazwa kosztu</b></v-flex>
					<v-flex xs2 style="padding: 5px;"><b>źródło finansowania</b></v-flex>
					<v-flex xs2 style="padding: 5px;"><b>kwota</b></v-flex>
					<v-flex xs1 style="padding: 5px"><b>akcje</b></v-flex>
				</v-layout>
			</v-card>
			<v-card outlined v-for="(cost, index) in actionsCosts" :key="cost.id">
				<v-layout>
					<v-flex style="padding: 5px" sm1>{{1 + index}}</v-flex>
					<v-flex style="padding: 5px" sm3>{{cost.projectAction.serialNumber}}. {{cost.projectAction.name}}
					</v-flex>
					<v-flex style="padding: 5px" sm3>{{cost.description}}
					</v-flex>
					<v-flex xs4>
						<v-layout v-for="(costDivision) in cost.costDivisions" :key="costDivision.id">
							<v-flex xs6 style="padding: 5px;">
								{{sourcePolishName(costDivision.financialSource)}}
							</v-flex>
							<v-flex xs6 style="padding: 5px;">
								{{formatMoney(costDivision.value)}}
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs1>
						<v-layout row>
							<egranty-icon-button
								icon="edit"
								label="Edytuj"
								:for="'invoice-form-costs-edit' + cost.id"
								:id="'invoice-form-costs-edit' + cost.id"
								@click="openEditCostDialog(cost)">
							</egranty-icon-button>
							<egranty-icon-button
								color="lightred"
								icon="delete"
								label="Usuń"
								:for="'invoice-form-costs-delete' + cost.id"
								:id="'invoice-form-costs-delete' + cost.id"
								@click="removeCost(cost)">
							</egranty-icon-button>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-card>
		</div>
		<v-card outlined>
			<h2 style="padding: 20px">A. Koszty administracyjne</h2>
			<v-card outlined>
				<v-layout>
					<v-flex style="padding: 5px" sm1><b>lp</b></v-flex>
					<v-flex style="padding: 5px" sm3></v-flex>
					<v-flex style="padding: 5px" sm3><b>nazwa kosztu</b></v-flex>
					<v-flex xs2 style="padding: 5px;"><b>źródło finansowania</b></v-flex>
					<v-flex xs2 style="padding: 5px;"><b>kwota</b></v-flex>
					<v-flex xs1 style="padding: 5px;"><b>akcje</b></v-flex>
				</v-layout>
			</v-card>
			<v-card outlined v-for="(cost, index) in administrativeCosts" :key="cost.id">
				<v-layout>

					<v-flex style="padding: 5px" sm1>{{1 + index}}</v-flex>
					<v-flex style="padding: 5px" xs3></v-flex>
					<v-flex style="padding: 5px" sm3>{{cost.description}}
					</v-flex>
					<v-flex xs4>
						<v-layout v-for="(costDivision) in cost.costDivisions" :key="costDivision.id">
							<v-flex xs6 style="padding: 5px;">
								{{sourcePolishName(costDivision.financialSource)}}
							</v-flex>
							<v-flex xs6 style="padding: 5px;">
								{{formatMoney(costDivision.value)}}
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex x1>
						<v-layout>
							<egranty-icon-button
								icon="edit"
								label="Edytuj"
								:for="'invoice-form-costs-edit' + cost.id"
								:id="'invoice-form-costs-edit' + cost.id"
								@click="openEditCostDialog(cost)">
							</egranty-icon-button>
							<egranty-icon-button
								color="lightred"
								icon="delete"
								label="Usuń"
								:for="'invoice-form-costs-delete' + cost.id"
								:id="'invoice-form-costs-delete' + cost.id"
								@click="removeCost(cost)">
							</egranty-icon-button>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-card>
		</v-card>
		<edit-invoice-modal
			@save="saveCost"
			ref="modal"
			:invoice-id="invoice.id"
			:project-id="projectId"
		/>

	</div>
</template>
<script>
	import EgrantyIconButton from "../../../../genericComponents/EgrantyIconButton";
	import EgrantySectionDivider from "../../../../genericComponents/EgrantySectionDivider";
	import {Numbers} from "@/utils/Numbers";
	import EditInvoiceModal from "./EditInvoiceModal";
	import {Invoice} from "@/api/generated/Invoice";

	export default {
		name: "InvoiceFormCosts",

		components: {EditInvoiceModal, EgrantySectionDivider, EgrantyIconButton},

		mixins: [Numbers],

		data() {
			return {
				financialSources: [
					{value: "DOTATION", text: "z dotacji"},
					{value: "OWN_FINANCIAL_CONTRIBUTION", text: "środki finansowe własne"},
					{value: "OWN_HUMAN_CONTRIBUTION", text: "wkład osobowy"},
					{value: "OWN_CONTRIBUTION_IN_KIND", text: "wkład rzeczowy"},
					{value: "MONEY_FROM_RECIPIENTS", text: "świadczenie pieniężne od odbiorców"},
					{value: "OTHER", text: "pozostałe"},
					{value: "OTHER_PUBLIC_SOURCE", text: "środki finansowe z innych źródeł publicznych"},
					{value: "INCOME", text: "przychody"},
					{value: "INTEREST", text: "odsetki"},
				],
			};
		},

		computed: {
			projectId() {
				return this.invoice.projectId;
			},

			actionsCosts() {
				return this.invoice.actionCosts.filter(x => x.projectAction !== null);
			},

			administrativeCosts() {
				return this.invoice.actionCosts.filter(x => x.projectAction === null);
			}
		},

		props: {
			invoice: {
				type: Object, default: () => {
				}, required: true
			},
		},


		methods: {

			openAddCostDialog() {
				this.$refs['modal'].openAddActionCost();
			},

			openAddAdministrativeCostDialog() {
				this.$refs['modal'].openAddAdministrativeCost();
			},

			openEditCostDialog(cost) {
				this.$refs['modal'].openEditCost(cost);
			},

			saveCost(cost) {
				if (cost.id === undefined) {
					let maxId = 0;
					for (let cost of this.invoice.actionCosts) {
						maxId = Math.max(maxId, cost.id);
					}
					cost.id = maxId + 1;
					this.invoice.actionCosts.push(cost);
					return;
				}
				const index = this.invoice.actionCosts.findIndex(x => x.id === cost.id);
				this.invoice.actionCosts.splice(index, 1, cost);
			},

			sourcePolishName(name) {
				return this.financialSources.find(x => x.value === name).text;
			},

			removeCost(cost) {
				const index = this.invoice.actionCosts.indexOf(cost);
				let invoiceCost = this.invoice.actionCosts[index];
				let actionId = invoiceCost.projectAction !== null ? invoiceCost.projectAction.id : "";
				let serialNumber = invoiceCost.serialNumber;
				Invoice.getIsReferenced(this, this.invoice.projectId, actionId, serialNumber, isReferenced => {
					if (isReferenced) {
						this.$confirm(
							'Czy na pewno chcesz usunąć koszt? Usunięcie tego kosztu spowoduje również usunięcie wszystkich kosztów, '
								+ 'które mają go podany jako "Pozycja już dodana w innych dokumentach".',
							{
								icon: 'delete',
								title: 'Usuwanie kosztu',
								color: 'lightred',
								width: 500
							}).then((response) => {
							if (response) {
								this.$delete(this.invoice.actionCosts, index);
							}
						});
					} else {
						this.$delete(this.invoice.actionCosts, index);
					}
				});
			},
		},
	};
</script>
